import { TextField } from '@mui/material';

interface PostLogoutRedirectUriFieldProps {
  value: string;
  error?: string;
  setValue: (value: string) => void;
}

function PostLogoutRedirectUriField({
  value,
  error,
  setValue,
}: PostLogoutRedirectUriFieldProps): React.JSX.Element {
  return (
    <TextField
      fullWidth
      label='Post Logout Redirect URI'
      value={value}
      error={Boolean(error)}
      helperText={error}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default PostLogoutRedirectUriField;

